export default __webpack_public_path__ + "static/media/Screenshot (1143).137df88d.png";